// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"419f1eed","5378":"edb30248","5532":"419f1eed"}[chunkId] + ".chunk.css";
};